import React, { Component } from 'react'
import { match } from 'react-router-dom'
import { GameWithOnlinePlayer } from './battle/GameWithOnlinePlayer'
import { AppHeader } from '../components/AppHeader'
import { Board as IBoard } from 'minimax_ttt'
import { IRoom, BoardObservable } from '../models'
import { Subscription } from 'rxjs';
import { firestore } from '../firebase';

const style = {
  marginTop: '100px'
};

type PageState = {
  room: IRoom | null,
  boards: { board: IBoard }[],
  subscription: Subscription[],
}

const initialState = (): PageState => ({
  room: null,
  boards: [{
    board: Array(9).fill(0) as IBoard
  }],
  subscription: []
})

export class BattlePage extends Component<{ match: match<{ id: string }> }, PageState> {
  state = initialState()

  async componentDidMount() {
    const { id } = this.props.match.params
    const boardObservable = new BoardObservable()
    boardObservable.getBoards(id, (boards) => {
      this.setState({ boards: boards.map(board => ({ board: board.board })) })
    })

    const docSnap = await firestore.collection('room').doc(id).get()
    const room = docSnap.data() as any
    room.id = docSnap.id
    if (!room) {
      throw Error('roomが取れませんでした')
    }
    this.setState({ room })
  }

  render() {
    if (!this.state.room) {
      return (
        <div className="container">
          <AppHeader />
          <div className="container" style={style}>
            <p>Loading...</p>
          </div>
        </div>
      )
    }
    return (
      <div className="container">
        <AppHeader />
        <div className="container" style={style}>
          <GameWithOnlinePlayer boards={this.state.boards} room={this.state.room} />
        </div>
      </div>
    )
  }
}
